import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import {
  FUNDED_RETURN_TYPE_OPTIONS,
  FundedReturnType,
} from '@/pages/instruments/new-instrument/constants/return-types'

export interface FundedReturnTypeFieldProps {}

export const FundedReturnTypeField: React.FC<FundedReturnTypeFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ funded_return_type: FundedReturnType }>()

  return (
    <FormField
      name="funded_return_type"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Funded Return Type</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              value={value}
              setValue={(value) =>
                setValue('funded_return_type', value as FundedReturnType, {
                  shouldValidate: true,
                })
              }
              placeholder={'Select a return type...'}
              options={FUNDED_RETURN_TYPE_OPTIONS}
            />
          </FormItem>
        )
      }}
    />
  )
}
